import React from "react";
import { WithDialog  } from "~/native-ui/Dialog";
import { DateTimePicker } from "./DateTimePicker";
import { DatePicker } from "./DatePicker";
import { TimePicker } from "./TimePicker";

const DateTimePickerWithDialog = (Component, extraProps) => {
    return WithDialog(React.memo((props) => {
        const { onChange, onOverlayClick, dialogRef } = props;
        const propsRef = React.useRef({ onChange, onOverlayClick, });

        const onValueChange = React.useCallback((value, shouldClose) => {
            propsRef.current.onChange?.(value);

            if (!shouldClose) { return; }
            propsRef.current.onOverlayClick?.();
            dialogRef.current?.toggleDialog?.();
        }, [propsRef, dialogRef])

        return <Component { ...props} onChange={onValueChange} />
    }), extraProps)
}

const dialogProps = { showCloseButton: true, isInline: true, _body: {pt: "0", p: "0"}, _close: { top: "5px", right: "5px" }}
export const DatePickerDialog = DateTimePickerWithDialog(DatePicker, dialogProps);
export const TimePickerDialog = DateTimePickerWithDialog(TimePicker, dialogProps);
export const DateTimePickerDialog = DateTimePickerWithDialog(DateTimePicker, dialogProps);